<template>
	<div class="station_right">
		<div class="station_right_in">
			<h2 class="station_right_h2">开发者信息</h2>
			<div class="dev_info_card msg_item_top">
				<ul>
					<li class="dev_list"><span>机构名称：</span><span v-text="orgName"></span></li>
					<li class="dev_list"><span>当前账号：</span><span v-text="userName"></span></li>
					<li class="dev_list"><span>APP-key：</span><span v-text="appkey"></span></li>
					<li class="dev_list">
						<span>APP-secret：</span>
						<span v-text="secret" id="foo"></span>
						<a @click="copy" href="javascript:;" class="copy_btn ft14 copyBtn" data-clipboard-target="#foo">复制</a>
					</li>
					<li class="dev_list"><span>机构编号：</span><span v-text="orgNo"></span></li>
					<!--<li><span>用户盐值：</span><span></span><a href="javascript:;" class="copy_btn ft14">复制</a></li>-->
				</ul>
				<div class="contact_card_btn">
					<a href="javascript:;" @click="changePassW">修改密码</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "developNews",
		data() {
			return {
				orgName: "",
        orgNo: sessionStorage.getItem('orgNo') || '',
				userName: "",
				appkey: "",
				secret: "",
				sdevId: "",
				userNameLocal: ""
			}
		},
		methods: {
			//修改密码
			changePassW() {
				this.$router.push({
					path: '/changePassword'
				}); //点击修改密码的时候会跳转到修改密码的界面
			},
			copy() {
				new Clipboard('.copyBtn');
				this.$Message.success({
					content: '已经复制APP-secret到剪切版！',
					duration: 3
				})
			}
		},
		mounted() { //相当于document.ready后执行的方法 ，DOM元素全部都加载完成之后执行的方法
			const that = this;
			this.sdevId = sessionStorage.getItem('devId');
			this.userNameLocal = sessionStorage.getItem('userName');
			let params = {
				"devId": this.sdevId,
				"username": this.userNameLocal
			};
			this.http.post('/ystOpenPlatformBff/getUserInfo', params, res => {
				if(res.success) {
					that.orgName = res.data.orgName; //机构名称
					that.userName = res.data.userName; //当前账号
					that.appkey = res.data.appkey; //key
					that.secret = res.data.secret; //secret

				} else {
					if(res.message){
						this.$Message.error(res.message);
					}
				}
			})

		}

	}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/_developCenter/DevelopNews.vue